module.exports = __webpack_public_path__ + "static/media/share.87038dd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/share.svg
// module id = 420
// module chunks = 0